import ApiConstants from "../../Constants/ApiConstant";
import { apiDelete, apiGet, apiPost, apiPut } from "../../Services/ApiService";

export const getProductDetailsAPI = (params, callBack) => {
  return async () => {
    try {
      let url = ApiConstants.productUrl;
      const queryParams = [];

      if (params.page)
        queryParams.push(`page=${encodeURIComponent(params.page)}`);
      if (params.limit)
        queryParams.push(
          `records_per_page=${encodeURIComponent(params.limit)}`
        );
      if (params?.searchQuery)
        queryParams.push(`search=${encodeURIComponent(params.searchQuery)}`);
      if (params.product_category_id) {
        queryParams.push(`product_category_id=${encodeURIComponent(params.product_category_id)}`);
      }
      if (params.product_id) {
        queryParams.push(`product_id=${encodeURIComponent(params.product_id)}`);
      }
      if (params.manufacturer_id) {
        queryParams.push(`manufacturer_id=${encodeURIComponent(params.manufacturer_id)}`);
      }
      // Append query parameters to URL if they exist
      if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
      }

      await apiGet(url)
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get product api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};

export const getProductByIdAPI = (productId, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.productUrl}?product_id=${productId}`)
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get product api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};

export const getProductByManufactureIdAPI = (manufactureId, callBack) => {
  return async () => {
    try {
      await apiGet(
        `${ApiConstants.productByManufactureIdUrl}?manufacture_id=${manufactureId}`
      )
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get product api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};

export const getProductMeltingByStampAPI = (stampPurityValue, callBack) => {
  return async () => {
    try {
      await apiGet(
        `${ApiConstants.productMeltingByStampUrl}?stamp_purity_value=${stampPurityValue}`
      )
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get product api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};

export const getAllCategorySubCategoryByUserIdAPI = (userId, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.getAllCategoryByUserIdUrl}?userId=${userId}`)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get product api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};

export const getProductsBySubCategoryId = (
  subCategoryId,
  callBack,
  params = {},
  manufactureId
) => {
  return async () => {
    try {
      let url = `${ApiConstants.productUrl}?product_subCategory_id=${subCategoryId}`;
      const queryParams = [];
      if (manufactureId) {
        queryParams.push(`manufacturer_id=${encodeURIComponent(manufactureId)}`);
      }
      if (params.page)
        queryParams.push(`page=${encodeURIComponent(params.page)}`);
      if (params.limit)
        queryParams.push(
          `records_per_page=${encodeURIComponent(params.limit)}`
        );
      if (params.searchQuery)
        queryParams.push(`search=${encodeURIComponent(params.searchQuery)}`);
      if (params.sortBy)
        queryParams.push(`sort_by=${encodeURIComponent(params.sortBy)}`);
      if (params.order)
        queryParams.push(`order=${encodeURIComponent(params.order)}`);

      // Append additional query parameters if present
      if (queryParams.length > 0) {
        url += `&${queryParams.join("&")}`;
      }

      await apiGet(url)
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get products by subCategory id api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};

// export const getProductsByMetalId = (metalId, callBack) => {
//   return async () => {
//     try {
//       await apiGet(`${ApiConstants.productUrl}?product_metal_id=${metalId}`)
//         .then((response) => {
//           callBack && callBack(response?.data, response?.data);
//         })
//         .catch((err) => {
//           console.log("get products by metal id api err:", err);
//           throw err;
//         });
//     } catch (err) {
//       console.log("get product api err:", err);
//       throw err;
//     }
//   };
// };

export const getProductsByMetalId = (metalId, callBack, params = {}) => {
  return async () => {
    try {
      let url = `${ApiConstants.productUrl}?product_metal_id=${encodeURIComponent(metalId)}`;
      const queryParams = [];

      if (params.page) queryParams.push(`page=${encodeURIComponent(params.page)}`);
      if (params.limit) queryParams.push(`records_per_page=${encodeURIComponent(params.limit)}`);
      if (params.searchQuery) queryParams.push(`search=${encodeURIComponent(params.searchQuery)}`);

      // Append query parameters to the URL if they exist
      if (queryParams.length > 0) {
        url += `&${queryParams.join("&")}`;
      }

      await apiGet(url)
        .then((response) => {
          callBack && callBack(response, response);
        })
        .catch((err) => {
          console.log("get products by metal id API error:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product API error:", err);
      throw err;
    }
  };
};

export const addProductsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.createProductUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("add product details api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("add product details api err:", err);
      throw err;
    }
  };
};

export const updateProductsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPut(ApiConstants.productUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("update product details api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("update product details api err:", err);
      throw err;
    }
  };
};

export const updateProductQuantityAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPut(ApiConstants.updateProductQuantityUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("update product details api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("update product details api err:", err);
      throw err;
    }
  };
};

export const deleteProductsAPI = (productId, callBack) => {
  return async () => {
    try {
      await apiDelete(`${ApiConstants.productUrl}?product_id=${productId}`)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("delete product details api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("delete product details api err:", err);
      throw err;
    }
  };
};

export const getTopSellingProductsAPI = (data, callBack) => {
  return async () => {
    // const url = `${ApiConstants.productUrl}?view_all_top_selling_products=${data?.view_all_top_selling_products}`;
    const queryData = { ...data };

    // Rename `limit` to `records_per_page` if it exists
    if (queryData.limit) {
      queryData.records_per_page = queryData.limit;
      delete queryData.limit;
    }

    // Build query string from data object
    const queryParams = new URLSearchParams(queryData).toString();
    const url = `${ApiConstants.productUrl}?${queryParams}`;
    try {
      await apiGet(url)
        .then((response) => {
          callBack && callBack(response, response);
        })
        .catch((err) => {
          console.log("get top selling products api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get top selling products api err:", err);
      throw err;
    }
  };
};
